<div class="ed">
  <div class="ed__modes" role="group" [attr.aria-label]="'SCOPE.TITLE' | translate">
    <button type="button" class="ed__mode" [attr.aria-pressed]="all()" (click)="chooseAll()">
      {{ 'SCOPE.ALL' | translate }}
    </button>
    <button type="button" class="ed__mode" [attr.aria-pressed]="!all()" (click)="chooseByLevel()">
      {{ 'SCOPE.BY_LEVEL' | translate }}
    </button>
  </div>

  @if (!all()) {
    @for (level of levels(); track level.pathId) {
      <fieldset class="ed__level">
        <legend class="ed__level-head">
          <input type="checkbox" [checked]="isWholeLevel(level)"
                 [indeterminate]="countOf(level) > 0 && !isWholeLevel(level)"
                 [attr.aria-label]="'SCOPE.WHOLE_LEVEL' | translate" (change)="toggleLevel(level)" />
          <span class="ed__level-title">{{ level.pathLabel || level.pathId }}</span>
          <span class="ed__count">{{ countOf(level) }} / {{ level.subjects.length }}</span>
        </legend>
        <div class="ed__subjects">
          @for (s of level.subjects; track s.id) {
            <label class="ed__subject">
              <input type="checkbox" [checked]="isChecked(level, s)" (change)="toggle(level, s)" />
              {{ subjectLabel(s) }}
            </label>
          }
        </div>
      </fieldset>
    } @empty {
      <p class="ed__empty">{{ 'SCOPE.NO_REFERENTIAL' | translate }}</p>
    }
  }
</div>
